import { extend } from "vee-validate";
import { confirmed, email, required, required_if, regex, min } from "vee-validate/dist/rules";
import { localize } from 'vee-validate'

localize('pl');
// Install rules
extend("required", required);
extend("confirmed", confirmed);
extend("email", email);
extend("min", min);
extend("regex", regex);
extend("required_if", required_if);
extend('nip', number => {
  const regex = RegExp('^\\d{10}$');
  return regex.test(number);
});
extend('phone', number => {
  const regex = RegExp('^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\./0-9]*$');
  return regex.test(number);
});

localize({
  pl: {
    messages: {
      required: 'To pole jest obowiązkowe',
      email: 'Email jest niepoprawny',
      confirmed: 'Hasła nie są takie same',
      phone: 'Niepoprawny numer telefonu',
      nip: 'Niepoprawny numer NIP'
    }
  }
});
